import { render } from "./error500.vue?vue&type=template&id=653ec5e8"
const script = {}

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__